import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@resy/ui-kitchen';
import { sanitizeString } from '../../../../../../../ui-kitchen/src/utils/sanitizeString';
import { handleMktAnalytics } from '../../AmexUtils';
import { CTA_EVENT_NAME } from '../../constants';
import './AmexFranchiseEditorialsCard.scss';

const AmexFranchiseEditorialsCard = (
  {
    Analytics,
    editorial: {
      image: {
        desktop: desktopImg,
        desktop_large: desktopImgLarge,
        desktop_small: desktopImgSmall,
        mobile: mobileImg,
      } = {},
      location,
      spot,
      title,
      copy,
      url,
    },
    editorialsImagePath,
    isApiFeed,
    matchMedia,
    utm = '',
  }
) => {
  const getDesktopImage = () => {
    if (desktopImg) return desktopImg;
    if (!desktopImg && spot === 'A') return desktopImgLarge;
    return desktopImgSmall;
  };

  const bgImage = matchMedia.md ? getDesktopImage() : mobileImg;
  const bgImageUrl = isApiFeed ? bgImage : `${editorialsImagePath}${bgImage}`;

  const sanitizedTitle = sanitizeString(title);
  const sanitizedLocation = sanitizeString(location);
  const sanitizedCopy = sanitizeString(copy);

  return (
    <div
      className="AmexFranchiseEditorialsCard"
      style={{
        backgroundImage: `url(${bgImageUrl})`,
      }}
    >
      <div className="AmexFranchiseEditorialsCard__content">
        {title && (
          <h3
            className="AmexFranchiseEditorialsCard__title"
          >
            <Link
              className="AmexFranchiseEditorialsCard__link"
              target="_blank"
              href={`${url}${utm}`}
              onClick={() => {
                handleMktAnalytics(Analytics?.event, CTA_EVENT_NAME, {
                  action_name: 'Editorial - Click',
                  item_name: sanitizedTitle,
                });
              }}
              dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                __html: sanitizedTitle,
              }}
            />
          </h3>
        )}
        {location && (
          <h4
            className="AmexFranchiseEditorialsCard__location"
            dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
              __html: sanitizedLocation,
            }}
          />
        )}
        {copy && (
          <p
            className="AmexFranchiseEditorialsCard__copy"
            dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
              __html: sanitizedCopy,
            }}
          />
        )}
      </div>
    </div>
  );
};

AmexFranchiseEditorialsCard.propTypes = {
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  editorial: PropTypes.shape({
    image: PropTypes.shape({
      desktop: PropTypes.string.isRequired,
      mobile: PropTypes.string.isRequired,
    }).isRequired,
    location: PropTypes.string.isRequired,
    spot: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    copy: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  editorialsImagePath: PropTypes.string,
  isApiFeed: PropTypes.bool.isRequired,
  matchMedia: PropTypes.shape({
    xs: PropTypes.bool,
    sm: PropTypes.bool,
    md: PropTypes.bool,
    lg: PropTypes.bool,
    xl: PropTypes.bool,
  }).isRequired,
  utm: PropTypes.string.isRequired,
};
AmexFranchiseEditorialsCard.defaultProps = {
  editorialsImagePath: null,
};

export default AmexFranchiseEditorialsCard;
